<template>
  <v-col :cols="12" :sm="12" :md="12">
    <Alertas
      :notificacaoSocket="alertaSocket"
      :texto="alerta.texto"
      :tipo="alerta.tipo"
    ></Alertas>

    <DataTable
      v-show="showSkeletonTable == false"
      :tableTitle="'Dispensas'"
      :tableHeader="headers"
      :tableRows="listOfDispensas"
      :isView="true"
      :isEdit="false"
      :isFinish="false"
      :isDel="false"
      :isPrint="false"
      :totalItens="totalDispensa"
      v-on:datatable-viewrow="viewDispensa"
      v-on:datatable-update-page="updatePage"
      v-on:datatable-update-search="updateSearch"
    ></DataTable>

    <SkeletonTable
      v-show="showSkeletonTable == true"
      :showSkeletonTable="showSkeletonTable"
    ></SkeletonTable>

    <Loading :open="loading" />

    <ModalCustomSize
      :modalSize="modalCustomSize.size"
      :isTheModalOpen="modalCustomSize.isOpen"
      :modalButtonText="modalCustomSize.buttonText"
      :modalFormTitle="modalCustomSize.formTitle"
      :modalType="modalCustomSize.modalType"
      :isLoadingRequestDisable="modalCustomSize.isLoadingRequestDisable"
      :isModalButtonVisible="modalCustomSize.isButtonsVisible"
      :isModalButtonDisabled="modalCustomSize.isButtonsDisabled"
      v-on:formmodal-close="modalCustomSize.isOpen = false"
    >
      <v-row>
        <v-col cols="12">
          <AlertasModal
            :tipo="alertaModal.tipo"
            :texto="alertaModal.texto"
          ></AlertasModal>
        </v-col>

        <v-col cols="6">
          <v-text-field
            v-model="modalCustomSize.receiveInfo.nomeEndereco"
            name="nomeEndereco"
            label="Nome da Unidade"
            readonly
          ></v-text-field>
        </v-col>

        <v-col cols="6">
          <v-text-field
            v-model="modalCustomSize.receiveInfo.nomeResponsavelUnidade"
            name="nomeResponsavelUnidade"
            label="Nome do Responsavel pela Unidade"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="6">
          <v-text-field
            v-model="modalCustomSize.receiveInfo.dataDispensa"
            name="dataDispensa"
            label="Data Dispensa"
            readonly
          ></v-text-field>
        </v-col>

        <v-col cols="6">
          <v-text-field
            v-model="modalCustomSize.receiveInfo.nomeFuncionario"
            name="nomeFuncionario"
            label="Responsável pela Dispensa"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <DataTable
            v-show="showSkeletonTableModal == false"
            :tableTitle="'Produtos na Dispensa'"
            :tableHeader="headersItens"
            :tableRows="modalCustomSize.receiveInfo.itensDispensa"
            :isEdit="false"
            :isFinish="false"
            :isDel="false"
            :isPrint="false"
          ></DataTable>

          <SkeletonTable
            v-show="showSkeletonTableModal == true"
            :showSkeletonTable="showSkeletonTable"
          ></SkeletonTable>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-select
            :items="status"
            label="Status da Dispensa"
            v-model="modalCustomSize.receiveInfo.indicadorStatus"
            readonly
          ></v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-textarea
            v-if="modalCustomSize.receiveInfo.descricaoContestar"
            counter
            label="Detalhes do contestamento"
            v-model="modalCustomSize.receiveInfo.descricaoContestar"
            readonly
          ></v-textarea>
        </v-col>
      </v-row>
    </ModalCustomSize>
  </v-col>
</template>

<script>
import axios from "../plugins/axios";
import store from "@/store/index";
import DataTable from "@/components/DataTable2.vue";
import Loading from "../components/Loading.vue";
import ModalCustomSize from "../components/ModalCustomSize";
import SkeletonTable from "../components/SkeletonTable";
import Alertas from "../components/Alertas.vue";
import AlertasModal from "../components/AlertasModal.vue";

export default {
  components: {
    DataTable,
    Loading,
    ModalCustomSize,
    SkeletonTable,
    Alertas,
    AlertasModal
  },

  sockets: {
    reciveUpdateUnidade: function (data) {
      if (data && data.descricaoTela == "ReceberItem") {
        this.newNotify.isNewNotify = true;
        this.newNotify.text = "Atualizado o status da dispensa: " + data.numeroDispensa;
        this.initialize();
      }
    },

    reciveInsert: function (data) {
      if (data && data.descricaoTela == "dispensa") {
        this.newNotify.isNewNotify = true;
        this.newNotify.text = "Nova Dispensa recebida!";
        this.initialize();
      }
    },
  },

  data: () => ({
    //Paginação 
    pageDispensa: 1,
    searchDispensa: null,
    totalDispensa: null,
    //Fim da paginação

    alerta: {
      texto: "",
      tipo: "",
    },

    alertaSocket: {
      texto: "",
      tipo: "",
    },

    alertaModal: {
      texto: "",
      tipo: "",
    },

    showSkeletonTable: true,
    showSkeletonTableModal: true,
    showTextField: false,
    loading: false,
    
    headers: [
      {
        text: "ID",
        value: "dispensa.numeroDispensa",
      },
      {
        text: "Unidade",
        value: "endereco.nomeEndereco",
      },
      {
        text: "Responsável pela Unidade",
        value: "endereco.nomeResponsavel",
      },
      {
        text: "Data Dispensa",
        value: "dispensa.dataDispensa",
      },
      {
        text: "Status",
        value: "dispensa.indicadorStatusDispensa",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    headersItens: [
      {
        text: "ID",
        value: "item.numeroItem",
      },
      {
        text: "Lote",
        value: "item.lote",
      },
      {
        text: "Nome Produto",
        value: "itemSistema.nomeItemSistema",
      },
      {
        text: "Validade",
        value: "item.validade",
      },
      {
        text: "Qt. Dispensada",
        value: "itemHistoricoDispensa.quantidadeDispensada",
      },
      {
        text: "Qt. Recebida",
        value: "itemHistoricoDispensa.quantidadeRecebida",
      },
    ],

    modalCustomSize: {
      size: "1500",
      isOpen: false,
      buttonText: "",
      formTitle: "",
      isEdit: false,
      isLoadingRequestDisable: false,
      isButtonsVisible: false,
      isButtonsDisabled: false,
      receiveInfo: {
        nomeEndereco: null,
        nomeResponsavelUnidade: null,
        nomeFuncionario: null,
        dataDispensa: null,
        indicadorStatus: null,
        descricaoContestar: null,
        quantidadeRecebidaItem: null,
        itensDispensa: []
      },
    },

    //Array populado pela função initialize
    listOfDispensas: [],
    status: [
      {
        text: "Aguardando Aprovação",
        value: 0,
      },
      {
        text: "Recebido",
        value: 1,
      },
      {
        text: "Recebido com Ressalva",
        value: 2,
      },
      {
        text: "Recusado",
        value: 3,
      },
    ],

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    }
  }),

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      this.showSkeletonTable = true;
      try {
        await this.listaTodasDispensas();
      } catch (error) {
        console.log(error);
      }
    },

    async listaTodasDispensas() {
      try {
        const listDispensa = await axios.put("dispensas", { page: this.pageDispensa, search: this.searchDispensa }, this.config);
        if(!listDispensa.data || listDispensa.data.length > 0) {
          this.listOfDispensas = listDispensa.data;
          this.totalDispensa = listDispensa.data[0].historicoDispensa.total
        }

        this.showSkeletonTable = false;
      } catch (error) {
        console.log(error);
        this.showSkeletonTable = false;
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      }
    },

    async updateSearch(search) {
      if(search){
        this.searchDispensa = search
        this.pageDispensa = 1
        await this.listaTodasDispensas()
      } else {
        this.pageDispensa = 1
      }
    },

    async updatePage(pagination) {
      this.pageDispensa = pagination.page
      await this.listaTodasDispensas()
    },

    async viewDispensa(dispensaSelecionada) {
      this.loading = true
      try {
        this.showSkeletonTableModal = true
        
        const listItens = await axios.put("itensHistoricoDispensa", { numeroDispensa: dispensaSelecionada.dispensa.numeroDispensa }, this.config);
        this.modalCustomSize.receiveInfo.itensDispensa = listItens.data;
        this.modalCustomSize.receiveInfo.nomeEndereco = dispensaSelecionada.endereco.nomeEndereco;
        this.modalCustomSize.receiveInfo.nomeResponsavelUnidade = dispensaSelecionada.endereco.nomeResponsavel;
        this.modalCustomSize.receiveInfo.nomeFuncionario = dispensaSelecionada.funcionario.nomeFuncionario;
        this.modalCustomSize.receiveInfo.dataDispensa = this._formatStringInBrazilianDateFormat(dispensaSelecionada.dispensa.dataDispensa);
        this.modalCustomSize.receiveInfo.indicadorStatus = dispensaSelecionada.dispensa.indicadorStatusDispensa;
        this.modalCustomSize.receiveInfo.descricaoContestar = dispensaSelecionada.dispensa.descricaoStatusDispensa;

      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
      } finally {
        this.modalCustomSize.formTitle = "Dispensa Selecionada";
        this.modalCustomSize.isEdit = true;
        this.modalCustomSize.isOpen = true;

        this.loading = false
        this.showSkeletonTableModal = false
      }
    },

    //#region FORMATADOR DE DATA
    _formatStringInBrazilianDateFormat(data) {
      if(data) {
        var ano  = data.split("-")[0];
        var mes  = data.split("-")[1];
        var dia  = data.split("-")[2];
        var dia2  = dia.substring(0,2)
        // Utilizo o .slice(-2) para garantir o formato com 2 digitos.
        return  ("0"+dia2).slice(-2) + '/' + ("0"+mes).slice(-2) + '/' +  ano;
      } else {
        return "Não informado!"
      }
    },
    //#endregion
  },
};
</script>